<input #field
       type="text"
       class="form-control"
       [ngModel]="innerValue"
       (ngModelChange)="writeValue($event)"
       [maxlength]="isUsa ? 5 : 7"
       (blur)="onTouched()"
       [placeholder]="placeholder || ''">
